import React, { useEffect, useMemo, useState, useCallback } from "react";
import PageTitle from "../../layouts/PageTitle";
import { ToastContainer } from "react-toastify";
import Select from "react-select";
import Table from "../../components/table/ReactTable/Table";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "../../../_store";
import { inventoryHistoryActions } from "../../../_store";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Button } from "react-bootstrap";
import transactionReportPDF from "../../components/export/transactionReportPDF";
import transactionReportXslx from "../../components/export/transactionReportXlsx";
import { useNavigate } from "react-router-dom";
import TransactionProductTable from "../../components/table/ReactTable/TransactionProductTable";

function TransactionProductReport() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const productDetailDrpList = useSelector(
    (x) => x.master.productDetailDrpList
  );
  const productInventoryList = useSelector(
    (x) => x.inventoryHistory.transactionProductReport
  );
  const [selectedProductID, setSelectedProductID] = useState({
    label: "Select Product",
    value: "",
  });
  const [viewFilter, setviewFilter] = useState([]);
  const [finalTableData, setFinalTableData] = useState([]);

  const handleTableDataUpdate = useCallback((data) => {
    setFinalTableData(data);
  }, []);

  useEffect(() => {
    getProductList();

    // Check if there's a stored product in localStorage
    const storedProduct = localStorage.getItem("selectedProduct");
    if (storedProduct) {
      const parsedProduct = JSON.parse(storedProduct);
      setSelectedProductID(parsedProduct);

      // Optional: fetch data for the stored product
      dispatch(
        inventoryHistoryActions.getTransactionProductReport(parsedProduct.value)
      );
    } else {
      // If nothing stored, set default
      setSelectedProductID({ label: "Select Product", value: "" });
    }
  }, [dispatch]);

  const PRODUCTS_COLUMNS = (viewFilter, navigateOrderViewPage) => [
    {
      Header: "Transaction Date",
      Footer: "Date",
      accessor: "CreatedDateString",
      justify: "center",
      fieldType: "Date",
      Filter: ColumnFilter,
    },
    {
      Header: "Transaction Type",
      Footer: "Transaction Type",
      accessor: "TransactionType",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Invoice Number",
      Footer: "Invoice Number",
      accessor: "InvoiceNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Transaction Order ID",
      Footer: "Transaction Order ID",
      accessor: "OrderNumber",
      justify: "center",
      Filter: ColumnFilter,
      Cell: ({ value, row }) => (
        <a
          href=" "
          onClick={(e) => {
            navigateOrderViewPage(e, row, viewFilter);
          }}
          style={{
            textDecoration: "underline",
            fontWeight: 700,
            cursor: "pointer",
            color: "#4281f5",
          }}
        >
          {value}
        </a>
      ),
    },
    {
      Header: "Transaction Unit",
      Footer: "Transaction Unit",
      accessor: "TransactionUnits",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Balance",
      Footer: "Balance",
      accessor: "FinalInventory",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Lot Number",
      Footer: "Lot Number",
      accessor: "LotNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
  ];
  const handleGetFilter = (id) => {
    setviewFilter([...id]);
  };

  const navigateOrderViewPage = (e, row, viewFilter) => {
    e?.preventDefault();
    if (viewFilter.length > 0) {
      localStorage.setItem("transactionTable", JSON.stringify(viewFilter));
    } else {
      console.log("viewFilter is empty inside the function");
    }

    const orderNumber = row?.original?.OrderNumber;
    const orderSts = row?.original?.OrderStatus;
    const orderID = row?.original?.OrderID;
    const clientID = row?.original?.ClientID;
    const OrderStatusID = row?.original?.OrderStatusID;

    navigate("/ViewOrder", {
      state: {
        OrderID: orderID,
        ClientID: clientID,
        OrderStatus: orderSts,
        OrderNumber: orderNumber,
        OrderStatusID: OrderStatusID,
        previousPage: "/TransactionProductReport",
      },
    });
  };
  const columns = useMemo(
    () => PRODUCTS_COLUMNS(viewFilter, navigateOrderViewPage),
    [viewFilter]
  );

  const generateColumns = [
    {
      header: "Transaction Date",
      dataKey: "CreatedDateString",
      cellWidth: 40,
    },
    {
      header: "Transaction Type",
      dataKey: "TransactionType",
      cellWidth: 40,
    },
    {
      header: "Invoice Number",
      dataKey: "InvoiceNumber",
      cellWidth: 40,
    },
    {
      header: "Transaction Order ID",
      dataKey: "OrderNumber",
      cellWidth: 30,
    },
    {
      header: "Transaction Unit",
      dataKey: "TransactionUnits",
      cellWidth: 14,
    },
    {
      header: "Balance",
      dataKey: "FinalInventory",
      cellWidth: 30,
    },
    {
      header: "Lot Number",
      dataKey: "LotNumber",
      cellWidth: 10,
    },
  ];

  const getProductList = () => {
    let ProductID = 0;
    let Status = 1;
    dispatch(masterActions.GetOrderProductDrpList({ ProductID, Status }));
    dispatch(inventoryHistoryActions.clearProductInventoryReport());
  };

  const handleProductChange = (e) => {
    const { value, label } = e;
    if (value === "" || value === 0) return;

    const selected = { label, value };
    setSelectedProductID(selected);

    // Persist to localStorage
    localStorage.setItem("selectedProduct", JSON.stringify(selected));

    // Dispatch your Redux action
    dispatch(inventoryHistoryActions.getTransactionProductReport(value));
  };

  const handleClickPDF = () => {
    let title = "Transaction Products Report";
    const columnStyles = {
      CreatedDateString: { halign: "center", cellWidth: 40 },
      TransactionType: { halign: "center", cellWidth: 40 },
      InvoiceNumber: { halign: "center", cellWidth: 30 },
      OrderNumber: { halign: "center", cellWidth: 30 },
      TransactionUnits: { halign: "center", cellWidth: 30 },
      FinalInventory: { halign: "center", cellWidth: 30 },
      LotNumber: { halign: "center", cellWidth: 40 },
    };

    transactionReportPDF(
      finalTableData,
      generateColumns,
      true,
      title,
      productInventoryList,
      columnStyles
    );
  };

  const handleClickExcel = () => {
    let title = "Transaction Products Report";
    let generateExcelColumns = [
      "Transaction Date",
      "Transaction Type",
      "Invoice Number",
      "Transaction Order ID",
      "Transaction Unit",
      "Balance",
      "Lot Number",
    ];
    let new_productList =
      finalTableData &&
      finalTableData?.map(function (obj) {
        return {
          CreatedDateString: obj.CreatedDateString,
          TransactionType: obj.TransactionType,
          InvoiceNumber: obj.InvoiceNumber,
          OrderNumber: obj.OrderNumber,
          TransactionUnits: obj.TransactionUnits,
          FinalInventory: obj.FinalInventory,
          LotNumber: obj.LotNumber,
        };
      });

    const productDetailHeaderData = {
      "Product SKU": productInventoryList?.SKU,
      "Product Name": productInventoryList?.ProductName,
      Location: productInventoryList?.Location,
      StockQuantity: productInventoryList?.StockQuantity,
    };

    transactionReportXslx(
      new_productList,
      productDetailHeaderData,
      generateExcelColumns,
      title
    );
  };

  return (
    <>
      <PageTitle
        activeMenu="Transaction Product Report"
        motherMenu="Products"
      />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">
            Transaction Product Report
          </h4>
          <div className="float-sm-end">
            {productInventoryList && productInventoryList.ProductID > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-3 mb-4">
              <label className="text-black font-w500 filtercss">Product</label>
              <div className="contact-name">
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="CategoryID"
                  value={selectedProductID}
                  onChange={(event) => handleProductChange(event)}
                  options={productDetailDrpList}
                />
              </div>
            </div>
          </div>
          {productInventoryList &&
          productInventoryList.ProductID > 0 &&
          Object.keys(productInventoryList).length > 0 ? (
            <div className="row">
              <div
                className=" col-12 d-flex ml-4 gap-2 mr-4 p-4 border border-md border-lg-0 custom-border-black shadow-lg rounded-lg"
                style={{ backgroundColor: "#f5f3f3" }}
              >
                <div className="col-6 d-flex flex-column gap-4">
                  <div className="d-flex gap-2  col-12">
                    <div className="text-black font-w500 filtercss col-2">
                      Product SKU :
                    </div>
                    <div className="text-black font-w500 filtercss col-10">
                      {productInventoryList?.SKU}
                    </div>
                  </div>

                  <div className="d-flex gap-2 col-12 ">
                    <div className="text-black font-w500 filtercss col-2">
                      Location :
                    </div>
                    <div className="text-black font-w500 filtercss col-10">
                      {productInventoryList?.Location}
                    </div>
                  </div>
                </div>

                <div className="col-6 d-flex flex-column gap-4">
                  <div className="d-flex gap-2 col-12">
                    <div className="text-black font-w500 filtercss col-3">
                      Product Name :
                    </div>
                    <div className="text-black font-w500 filtercss col-9">
                      {productInventoryList?.ProductName}
                    </div>
                  </div>

                  <div className="d-flex gap-2 col-12 ">
                    <div className="text-black font-w500 filtercss col-3">
                      Stock Quantity :
                    </div>
                    <div className="text-black font-w500 filtercss col-9">
                      {productInventoryList?.StockQuantity}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <TransactionProductTable
                  columns={columns}
                  data={productInventoryList?.TransactionHistoryModelList}
                  getFilterValue={(id) => handleGetFilter(id)}
                  onDataUpdate={handleTableDataUpdate}
                />
              </div>
            </div>
          ) : (
            <div className="row d-flex justify-content-center justify-content-center fs-3">
              Select Product to get an Inventory Report
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TransactionProductReport;
